// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QJgLdTZO7VF3yyahQ0oD {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-height: 40vh;
    text-align: center;
}

.dERd_b0RD3Wz6aUX7Xbo {
    width: 100%;
    max-width: 28rem;
}

.ZiRO71x8T42Yc2anG40Z {
    color: var(--color-primary-black);
    text-decoration: underline;
    cursor: pointer;
    display: inline-block;
    font-size: 1rem;
    line-height: 1.5;
    padding: 0;
    border: 0;
    background: none;
}

.ZiRO71x8T42Yc2anG40Z:visited {
    color: var(--color-primary-black);
}

.ZiRO71x8T42Yc2anG40Z:focus {
    outline: none;
}

.ZiRO71x8T42Yc2anG40Z:focus-visible {
    outline: none;
}`, "",{"version":3,"sources":["webpack://./src/features/auth/components/GeneralError/GeneralError.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,iCAAiC;IACjC,0BAA0B;IAC1B,eAAe;IACf,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB","sourcesContent":[".main {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    min-height: 40vh;\n    text-align: center;\n}\n\n.errorContainerInner {\n    width: 100%;\n    max-width: 28rem;\n}\n\n.backLink {\n    color: var(--color-primary-black);\n    text-decoration: underline;\n    cursor: pointer;\n    display: inline-block;\n    font-size: 1rem;\n    line-height: 1.5;\n    padding: 0;\n    border: 0;\n    background: none;\n}\n\n.backLink:visited {\n    color: var(--color-primary-black);\n}\n\n.backLink:focus {\n    outline: none;\n}\n\n.backLink:focus-visible {\n    outline: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `QJgLdTZO7VF3yyahQ0oD`,
	"errorContainerInner": `dERd_b0RD3Wz6aUX7Xbo`,
	"backLink": `ZiRO71x8T42Yc2anG40Z`
};
module.exports = ___CSS_LOADER_EXPORT___;
